/* @flow */

import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getImageStrategy, getImage } from '../reducers/images';
import * as ImagesActions from '../actions/images';
import OctoResourceCard from 'shared/components/OctoResourceCard';

type Props = {
  imageStrategy?: ResourceStrategy,
  image?: CatalogResource,
  updateImage: (resource: CatalogResource) => void,
  deleteImage: () => void,
};

const mapStateToProps = state => ({
  imageStrategy: getImageStrategy(state),
  image: getImage(state),
});

const ImagesCard = ({
  imageStrategy,
  image,
  updateImage,
  deleteImage,
}: Props) => {
  if (imageStrategy) {
    return (
      <Segment attached>
        <Header textAlign="center">Image titre</Header>
        <OctoResourceCard
          strategy={imageStrategy}
          resource={image}
          onUpdated={updateImage}
          onDeleted={deleteImage}
        />
      </Segment>
    );
  }

  return null;
};

export default connect(mapStateToProps, {
  updateImage: ImagesActions.updateImage,
  deleteImage: ImagesActions.deleteImage,
})(ImagesCard);



// WEBPACK FOOTER //
// ./src/modules/calendar/components/ImagesCard.js